"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var errorMessages_1 = __importDefault(require("../../libs/constants/errorMessages"));
var respond_1 = __importDefault(require("../../utils/respond"));
var request_1 = __importDefault(require("../../utils/request"));
var form_data_1 = __importDefault(require("form-data"));
function default_1(uploadOptions, defaultOptions, callback) {
    if (!lodash_1.default.isObject(uploadOptions)) {
        (0, respond_1.default)(true, errorMessages_1.default.MISSING_UPLOAD_DATA, callback);
        return;
    }
    if (!uploadOptions.file) {
        (0, respond_1.default)(true, errorMessages_1.default.MISSING_UPLOAD_FILE_PARAMETER, callback);
        return;
    }
    if (!uploadOptions.fileName) {
        (0, respond_1.default)(true, errorMessages_1.default.MISSING_UPLOAD_FILENAME_PARAMETER, callback);
        return;
    }
    var formData = {};
    var form = new form_data_1.default();
    var key;
    for (key in uploadOptions) {
        if (key) {
            if (key == "file" && typeof uploadOptions.file != "string") {
                // form.append('file', uploadOptions.file);
                form.append('file', uploadOptions.file, String(uploadOptions.fileName));
            }
            else if (key == "tags" && Array.isArray(uploadOptions.tags)) {
                form.append('tags', uploadOptions.tags.join(","));
            }
            else if (key == "responseFields" && Array.isArray(uploadOptions.responseFields)) {
                form.append('responseFields', uploadOptions.responseFields.join(","));
            }
            else if (key == "extensions" && Array.isArray(uploadOptions.extensions)) {
                form.append('extensions', JSON.stringify(uploadOptions.extensions));
            }
            else if (key === "customMetadata" && typeof uploadOptions.customMetadata === "object" &&
                !Array.isArray(uploadOptions.customMetadata) && uploadOptions.customMetadata !== null) {
                form.append('customMetadata', JSON.stringify(uploadOptions.customMetadata));
            }
            else {
                form.append(key, String(uploadOptions[key]));
            }
        }
    }
    var requestOptions = {
        url: defaultOptions.uploadEndpoint || "https://upload.imagekit.io/api/v1/files/upload",
        method: "POST",
        formData: form
    };
    (0, request_1.default)(requestOptions, defaultOptions, callback);
}
exports.default = default_1;
